export default "__VITE_ASSET__BOJg88$U__"